import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import React from "react";
import Chart from "react-apexcharts";
import { useChartBase, mergeChartOptions } from "_shared/ui/chartTheme";

const ExpenseBreakup = ({ isBreakupOpen, handleBreakupClose, data }) => {
  console.log("dtaa", data);

  const chartBase = useChartBase();
  const options = mergeChartOptions(chartBase, {
    labels: data?.map((d) => d?._id),
    legend: { position: "bottom" },
  });

  return (
    <>
      <Modal open={isBreakupOpen} onClose={handleBreakupClose}>
        <Box
          sx={{
            width: { xs: "90%", sm: "60%", md: "40%" },
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            border: "none",
            boxShadow: 24,
            p: 4,
            textAlign: "left",
            maxHeight: "80vh",
            overflowY: "auto",
          }}
        >
          <Stack spacing={1.5}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, textAlign: "center", mb: 1 }}
            >
              Expense Breakup
            </Typography>

            <Chart
              type="donut"
              width={"100%"}
              height={"100%"}
              series={data?.map((d) => d?.totalAmount)}
              options={options}
            />

            <Button
              variant="outlined"
              onClick={handleBreakupClose}
              sx={{ width: 200, ml: "auto", mt: 2 }}
            >
              Cancel
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default ExpenseBreakup;
